
        var result = require("!!../../../../node_modules/css-loader/index.js!./reservation.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/reservation/reservation.component.css
// module id = 481
// module chunks = 2